import { ReactNode } from 'react';
import './Title.scss';

export interface TitleProps {
  children: ReactNode | [ReactNode];
}

export function Title(props: TitleProps) {
  return <div className="title-container">{props.children}</div>;
}
